import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { getTrainingVideosAPI, watchTrainingVideoAPI } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';
import { VideoTraining } from './VideoTraining';

@Injectable({
  providedIn: 'root'
})

export class TrainingVideosService {

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getTrainingVideos(): Observable<VideoTraining[]> {
    const body = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      // tslint:disable-next-line: radix
      userId: parseInt(localStorage.getItem('userId')),
      app: 'insync',
      userType: 'inspector'
    };
    return this.http.post<VideoTraining[]>(getTrainingVideosAPI, body)
    .pipe(
      catchError(this.handleError('getTrainingVideos', []))
    );
  }

  watchTrainingVideo(trainingVideoId: number): Observable<any> {
    const date = new Date();
    const body = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      trainingVideoId,
      // tslint:disable-next-line: radix
      watchedId: parseInt(localStorage.getItem('userId')),
      timeWatched: `${date.toISOString().split('T')[0]} ${date.toTimeString().split(' ')[0]}`,
    };
    return this.http.post<any>(watchTrainingVideoAPI, body)
    .pipe(
      catchError(this.handleError('watchTrainingVideo', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.log(error);
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
